import { GetDealResponse } from "../../../../service/query";

const TERMINAL_DEAL_STATUSES = ["Approved", "Rejected", "Cancelled"];

export const isDealEditable = (deal: GetDealResponse | undefined): boolean =>
  !!deal && !TERMINAL_DEAL_STATUSES.includes(deal.status ?? "");
